<template>
  <i-modal
    modal-id="create-workspace-modal"
    title="New Workspace"
    confirm-button-text="Create"
    type="primary"
    @on-submit="createNewWorkspace"
    @on-close="onClose"
  >
    <template #body-content>
      Note that this step cannot be undone. Learn more about creating Workspaces
      at our
      <a
        href="https://help.inscribe.ai/en/articles/6719171-workspaces"
        target="_blank"
        rel="noopener"
        >Help Center</a
      >.
      <div class="workspace-name-field">
        <i-text-input
          id="webhook-url"
          class="i-my-10"
          label="Name"
          placeholder="Enter Workspace Name"
          :value="workspaceName"
          data-testid="workspace-name-field"
          :has-error="hasError"
          :show-hint-text="hasError"
          hint-text="Workspace name already exists"
          @input="workspaceName = $event"
        ></i-text-input>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { iTextInput, iModal, openModal } from '@inscribe/signal';
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  components: {
    iTextInput,
    iModal,
  },
  data() {
    return {
      workspaceName: undefined,
    };
  },
  computed: {
    ...mapState(['workspaces']),

    hasError() {
      const workSpaceNames = this.workspaces.map((workspace) => {
        return workspace.name;
      });
      return workSpaceNames.includes(this.workspaceName);
    },
  },
  mounted() {
    openModal('create-workspace-modal');
  },
  methods: {
    ...mapActions(['createWorkspace']),
    ...mapMutations(['updateWorkspaces']),
    onClose() {
      this.$emit('close-create-workspace-modal');
    },

    createNewWorkspace() {
      const created = this.createWorkspace(this.workspaceName);

      created.then((response) => {
        this.updateWorkspaces(response.data);
      });
    },
  },
};
</script>
